var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL OPERATIONS","title":"Finance Management","description":"Manage fees, payments, income, expenses and financial reporting.","count-label":"finance tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }